import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { Alert, Card, Spinner } from "@prequel/shared-components";

import { useLoginToken } from "@/api/queries/auth";

const LoginSuccessfulCard = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  const { mutate, isError, error, reset } = useLoginToken();

  useEffect(() => {
    if (code && state) {
      mutate({ code, state });
    } else {
      navigate("/login");
    }
  }, [code, state, mutate, navigate]);

  return (
    <div className="flex justify-center pt-36">
      <Card>
        {isError ? (
          <Alert>{error?.message || "An error occurred"}</Alert>
        ) : (
          <div className="flex items-center justify-center text-xl text-gray-700">
            <div className="mr-4">{"Logging you in... "}</div>
            <Spinner.Inline className="mr-3" />
          </div>
        )}
        <div className="flex justify-center text-sm text-gray-500">
          <div className="mr-1">Having trouble logging in?</div>
          <div
            className="
              cursor-pointer text-primary-600
              hover:underline
            "
            onClick={() => {
              reset();
              navigate("/login");
            }}
          >
            Try again
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LoginSuccessfulCard;
